<template>
    <v-menu
        v-model="menuState"
        :close-on-content-click="closeOnContentClick"
        v-bind="menuProps"
        allow-overflow
        :content-class="removable && hideMenu ? 'elevation-0 overflow-y-hidden dropmenu rounded-lg' : 'overflow-y-hidden dropmenu rounded-lg'"
        style="overflow-y: hidden !important"
    >
        <template v-slot:activator="{ on }">
            <slot :on="on" />
        </template>
        <v-card
            v-if="!hideMenu"
            class="ma-0 pa-0"
            :style="computed_min_width_style_string"
            style="max-height: 100%; min-width: 300px"
        >
            <v-card-title v-if="menuTitle" class="ma-0 py-2 px-4" style="border-bottom: 1px solid lightgrey">
                <span class="font-weight-regular">{{ menuTitle }}</span>
            </v-card-title>
            <v-card-title class="ma-0 pa-0">
                <v-text-field
                    v-show="searchable"
                    ref="selectsearch"
                    v-model="search"
                    :placeholder="$t('Search')"
                    :color="color"
                    hide-details
                    single-line
                    shaped
                    outlined
                    autofocus
                    class="mt-0 pt-0 search-field"
                    style="min-width: 304px"
                    clearable
                    clear-icon="mdi-close"
                    @click:clear="clearSearch"
                >
                    <template slot="append">
                        <div class="mr-1">
                            <icon
                                v-show="!search"
                                size="16"
                                color="grey"
                                icon="Search"
                            />
                        </div>
                    </template>
                </v-text-field>
            </v-card-title>
            <v-card-text class="ma-0 pa-0 py-2 x-borders" style="overflow: auto; max-height: 333px;">
                <div v-if="showSelectedFirst">
                    <div v-show="selected_filtered_items.length > 0">
                        <DropMenuList
                            :avatars="avatars"
                            :avatar-circular-rule-func="avatarCircularRuleFunc"
                            :items="selected_filtered_items"
                            :item-name="itemName"
                            :is-selected="isSelected"
                            :select="select"
                            :text-color="textColor"
                            :hover-action="hoverAction"
                            :computed-min-width="computed_min_width_style_string"
                            :avatar-key="avatarKey"
                            :color-key="colorKey"
                            :avatar-initials-class-key="avatarInitialsClassKey"
                            :avatar-initials-class="avatarInitialsClass"
                            :avatar-initials-key="avatarInitialsKey"
                            :icon-key="iconKey"
                            :icon="icon"
                            :icon-color="iconColor"
                            :color="color"
                            :enable-hover-action="enableHoverAction"
                            :capitalize="capitalize"
                        />
                    </div>
                    <div v-show="unselected_filtered_items.length > 0">
                        <DropMenuList
                            :avatars="avatars"
                            :avatar-circular-rule-func="avatarCircularRuleFunc"
                            :items="unselected_filtered_items"
                            :item-name="itemName"
                            :is-selected="isSelected"
                            :select="select"
                            :text-color="textColor"
                            :hover-action="hoverAction"
                            :computed-min-width="computed_min_width_style_string"
                            :avatar-key="avatarKey"
                            :color-key="colorKey"
                            :avatar-initials-class-key="avatarInitialsClassKey"
                            :avatar-initials-class="avatarInitialsClass"
                            :avatar-initials-key="avatarInitialsKey"
                            :icon-key="iconKey"
                            :icon="icon"
                            :color="color"
                            :enable-hover-action="enableHoverAction"
                            :capitalize="capitalize"
                        />
                    </div>
                </div>
                <div v-else>
                    <DropMenuList
                        :avatars="avatars"
                        :avatar-circular-rule-func="avatarCircularRuleFunc"
                        :items="filtered_items"
                        :item-name="itemName"
                        :is-selected="isSelected"
                        :select="select"
                        :text-color="textColor"
                        :hover-action="hoverAction"
                        :computed-min-width="computed_min_width_style_string"
                        :avatar-key="avatarKey"
                        :color-key="colorKey"
                        :avatar-initials-class-key="avatarInitialsClassKey"
                        :avatar-initials-class="avatarInitialsClass"
                        :avatar-initials-key="avatarInitialsKey"
                        :icon-key="iconKey"
                        :icon="icon"
                        :icon-color="iconColor"
                        :color="color"
                        :enable-hover-action="enableHoverAction"
                        :capitalize="capitalize"
                    />
                </div>
            </v-card-text>
            <v-card-actions
                v-show="filtered_items.length > 0 && toggleSelect && multi && deselect"
                class="ma-0 pa-0 x-borders"
                style="height: 38px;border-top: 1px solid lightgrey"
            >
                <div>
                    <a class="py-2 px-3" @click="toggleAll">
                        <span class="primary--text text--darken-2 body-2" style="white-space:nowrap">
                            {{ strings.toggle }}
                        </span>
                    </a>
                </div>
                <div v-show="filtered_items.length === 0" class="white px-3 py-2">
                    <span class="grey--text text--darken-2 body-2">No results</span>
                </div>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
import DropMenuList from "./Legacy_DropMenuList.vue";
import { $t } from "@/i18n";

/**
 * Replace with the dropmenu that our filters use, will cause some issues with appNavigationDrawer
 */
export default {
    name: "DropMenu",
    components: { DropMenuList },
    filters: {},
    props: {
        strings: {
            type: Object,
            default: () => {
                return {
                    toggle: $t("select/unselect all")
                };
            }
        },
        removable: {
            type: Boolean,
            default: false
        },
        showSelectedFirst: {
            type: Boolean,
            default: true
        },
        hideMenu: {
            type: Boolean,
            default: false
        },
        menuTitle: {
            type: String,
            default: ""
        },
        openOnHover: {
            type: Boolean,
            default: false
        },
        avatars: {
            type: Boolean,
            default: false
        },
        attach: {
            type: String,
            default: ""
        },
        toggleSelect: {
            type: Boolean,
            default: true
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        value: {
            type: Array,
            default: () => []
        },
        items: {
            type: [Array, Object, Function],
            required: true
        },
        multi: {
            type: Boolean,
            default: false
        },
        deselect: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: "mdi-check"
        },
        color: {
            type: String,
            default: "primary"
        },
        textColor: {
            type: String,
            default: "grey--text text--darken-2"
        },
        valueKey: {
            type: String,
            default: ""
        },
        nameKey: {
            type: String,
            default: ""
        },
        colorKey: {
            type: String,
            default: ""
        },
        iconColor: {
            type: String,
            default: "grey"
        },
        avatarKey: {
            type: String,
            default: ""
        },
        avatarInitialsClass: {
            type: String,
            default: ""
        },
        avatarInitialsClassKey: {
            type: String,
            default: "initials_class"
        },
        avatarCircularRuleFunc: {
            type: Function,
            default: () => true
        },
        iconKey: {
            type: String,
            default: ""
        },
        avatarInitialsKey: {
            type: String,
            default: ""
        },
        menuHeight: {
            type: Number,
            default: 300
        },
        searchable: {
            type: Boolean,
            default: false
        },
        reverseSelect: {
            type: Boolean,
            default: false
        },
        menuMinWidth: {
            type: Number,
            default: null
        },
        closeOnContentClick: {
            type: Boolean,
            default: false
        },
        capitalize: {
            type: Boolean,
            default: false
        },
        menuProps: {
            type: Object,
            default: () => ({ "offset-y": true })
        },
        onChangeFunc: {
            type: Function,
            default: () => []
        },
        customRules: {
            type: Function,
            default: null
        },
        enableHoverAction: {
            type: Boolean,
            default: false
        },
        hoverAction: {
            type: Function,
            default: () => {}
        },
        highlightId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            search: "",
            menuState: false
        };
    },
    computed: {
        computed_items() {
            if (this.isFunction(this.items)) {
                return this.items();
            } else {
                return this.items;
            }
        },
        computed_height() {
            if (this.toggleSelect && this.multi && this.deselect && this.filtered_items.length > 0) {
                return "max-height:" + this.menuHeight + "px; overflow: auto; margin-bottom: 38px;";
            } else {
                return "max-height:" + this.menuHeight + "px; overflow: auto;";
            }
        },
        computed_min_width_style_string() {
            return "min-width:" + this.menuMinWidth + "px;";
        },
        filtered_items() {
            if (!this.computed_items.length) {
                return [];
            }
            return this.computed_items.filter(i => {
                if (!this.search) {
                    return true;
                }
                return String(this.itemName(i))
                    .toLowerCase()
                    .includes(this.search.toLowerCase());
                // if (typeof i === 'string') {
                //     return i.toLowerCase().includes(this.search.toLowerCase());
                // } else {
                //     if(this.nameKey){
                //         return String(i[this.nameKey]).toLowerCase().includes(this.search.toLowerCase())
                //     } else {
                //         return String(i[this.valueKey]).toLowerCase().includes(this.search.toLowerCase())
                //     }
                //
                // }
            });
        },
        unselected_filtered_items() {
            return this.filtered_items.filter(
                i => !this.value.find(val_i => val_i[this.valueKey] === i[this.valueKey])
            );
        },
        selected_filtered_items() {
            return this.filtered_items.filter(
                i => !!this.value.find(val_i => val_i[this.valueKey] === i[this.valueKey])
            );
        }
    },
    watch: {
        isOpen(val) {
            this.menuState = val;
        },
        menuState(val, prev) {
            this.clearSearch();
            this.$emit("update:isOpen", val);
            if (!val && !!prev) {
                this.$emit("trigger_lazy_update");
            }
            if (val && this.searchable) {
                const input = this.$refs.selectsearch;
                if (input) {
                    setTimeout(function() {
                        input.focus();
                    }, 100);
                }
            }
        }
    },
    methods: {
        toggleAll() {
            const all = [].concat(this.filtered_items);
            if (this.value.length < all.length) {
                this.$emit("input", all);
            } else {
                this.$emit("input", []);
            }
            this.$emit("trigger_update");
        },
        clearSearch() {
            this.search = "";
        },
        select(item) {
            if (Array.isArray(this.value)) {
                let matching_indexes;
                if (typeof item === "object") {
                    const valueKey = this.valueKey;
                    matching_indexes = this.value.reduce(function(filtered, i, index) {
                        if (i[valueKey] === item[valueKey]) {
                            filtered.push(index);
                        }
                        return filtered;
                    }, []);
                } else {
                    matching_indexes = this.value.reduce((filtered, i, index) => {
                        if (i === item) {
                            filtered.push(index);
                        }
                        return filtered;
                    }, []);
                }
                if (matching_indexes.length && this.deselect) {
                    matching_indexes
                        .sort()
                        .reverse()
                        .forEach(idx => {
                            this.value.splice(idx, 1);
                        });
                } else {
                    if (this.multi) {
                        if (!matching_indexes.length) {
                            this.value.push(item);
                        }
                    } else {
                        this.value.pop();
                        this.value.push(item);
                    }
                }
                this.onChangeFunc();
            } else {
                this.value = "ERROR not selection model is not an Array";
            }
            this.$emit("input", this.value);
            this.$emit("trigger_update");
        },
        isSelected(item) {
            if (this.reverseSelect) {
                if (this.customRules) return !this.customRules(item, this.items);
                if (typeof item === "string") {
                    return !this.value.some(s => s.toLowerCase() === item.toLowerCase());
                } else if (typeof item === "object") {
                    return !this.value.some(
                        s => String(s[this.valueKey].toLowerCase()) === String(item[this.valueKey]).toLowerCase()
                    );
                }
            } else {
                if (this.customRules) return this.customRules(item, this.items);
                if (typeof item === "string") {
                    return this.value.some(s => String(s).toLowerCase() === String(item).toLowerCase());
                } else if (typeof item === "object") {
                    // if(this.value.length){
                    //     console.log("isSelected", this.valueKey, this.value);
                    // }
                    return this.value.some(
                        s =>
                            s !== null &&
                            String(s[this.valueKey]).toLowerCase() === String(item[this.valueKey]).toLowerCase()
                    );
                }
            }
        },
        itemName(item) {
            if (typeof item === "string") {
                return item;
            } else if (typeof item === "object") {
                if (this.nameKey) {
                    if (this.highlightId && item[this.valueKey] === this.highlightId) {
                        return '# ' + item[this.nameKey]
                    }

                    return item[this.nameKey];
                } else if (this.valueKey) {
                    return item[this.valueKey];
                } else return "object keys undefined";
            }
        },
        isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";
        }
    }
};
</script>
